import React, { useMemo } from "react";
import { useList } from "@/hooks/lists.ts";
import { useSnapshot } from "valtio/react";
import { taskCountState } from "@/states.ts";

export interface TaskCountProps {
	listId: string;
}

const TaskCount: React.FC<TaskCountProps> = (props) => {
	const list = useList(props.listId);
	const tasksCountSnap = useSnapshot(taskCountState);
	const listTaskCount = useMemo(() => {
		return tasksCountSnap.lists[props.listId];
	}, [props.listId, tasksCountSnap]);

	const count = useMemo(() => {
		if (!listTaskCount) return list?.task_count;

		if (!list || !list.tasks_last_update) {
			if (listTaskCount) return listTaskCount.count;
			return null;
		}

		const listItemsDate = new Date(list.tasks_last_update);
		const cachedListTaskDate = new Date(listTaskCount.date);

		if (cachedListTaskDate > listItemsDate) {
			return listTaskCount.count;
		}

		return list.task_count;
	}, [listTaskCount, list]);
	if (!count) return null;

	return (
		<div
			className={
				"bg-opacity-30 opacity-80 min-w-5 h-5 text-center rounded text-secondary-foreground p-1"
			}
			style={{
				lineHeight: "12px",
				backgroundColor:
					"hsl(var(--secondary-foreground) / var(--tw-bg-opacity))",
			}}
		>
			{count}
		</div>
	);
};

export { TaskCount };
